import React from 'react';
import { TableCell, TableRow, Button, Link as MuiLink } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { DateTime } from 'luxon';

function MembershipEventTableRow({ membershipEvent, confirmDeleleteMembershipEvent }) {
  return (
    <>
      <TableRow>
        <TableCell>{membershipEvent.title}</TableCell>
        <TableCell>
          {DateTime.fromISO(membershipEvent.starts_at)
            .setZone(membershipEvent.time_zone, { keepLocalTime: true })
            .toLocaleString({
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })}{' '}
          -{' '}
          {DateTime.fromISO(membershipEvent.ends_at)
            .setZone(membershipEvent.time_zone, { keepLocalTime: true })
            .toLocaleString({
              hour: '2-digit',
              minute: '2-digit',
              timeZoneName: 'short',
            })}
        </TableCell>
        <TableCell>
          <MuiLink href={membershipEvent.link} target="_blank" rel="noopener">
            RSVP
          </MuiLink>
          <br />
          <MuiLink
            href={membershipEvent.attend_url ?? '#'}
            style={{ whiteSpace: 'nowrap' }}
            target="_blank"
            rel="noopener">
            {membershipEvent.attend_url ? 'Attend' : '<Attend Not Set>'}
          </MuiLink>
        </TableCell>
        <TableCell>
          <Link textDecoration={'none'} to={`/membership-events/edit/${membershipEvent.id}`}>
            <Button>Edit</Button>
          </Link>
          <Button color="secondary" onClick={() => confirmDeleleteMembershipEvent(membershipEvent.id)}>
            Delete
          </Button>
        </TableCell>
      </TableRow>
    </>
  );
}

export default MembershipEventTableRow;
